import { Box } from "@tuteria/shared-lib/src/chakra";
import { CLIENT_PAGES } from "@tuteria/shared-lib/src/stores/client-types";
import React from "react";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";
import { initializeStore } from "./adapter";
import App from "./App";
import {
  renderReviewGuarantors,
  unMountReviewGuarantors,
} from "./ReviewGuarantors";
import {
  renderReviewComponent,
  unMountReviewComponent,
} from "./ReviewImageUpload";
import { renderSalesModal, unMountSalesModal } from "./SalesAdminModal";
import { initializeAdmin } from "./TutorAdmin";
import { initializeFollowupAdmin } from "./RequestFollowUp";
import {
  renderJobApplicationButton,
  unMountJobApplication,
} from "./jobApplyButton";

import { linkRequestModal, unMountLinkRequestModal } from "./BookingAdmin";
import { sendWhatsappMessageToClient } from "./WhatsappModal";
import { displaySplitBreakdown } from "./SplitBreakdownModal";
import { loadTutorVideoIntro } from "./TutorVideoIntroduction";
import { customSearch } from "./CustomSearchModal";
const PROXY_URL = process.env.REACT_APP_API_URL;

function loadApplication(kind, initialData, baseUrl = "", otherProps = {}) {
  const { store, adapter, isLiteTutor, liteLocation } = initializeStore(
    baseUrl,
    initialData[kind]
  );
  ReactDOM.render(
    <React.StrictMode>
      <Box bg="white" height={{ base: "110vh", lg: "90vh" }}>
        <App
          store={store}
          page={kind}
          initialData={initialData[kind]}
          saveTutorInfo={adapter.saveTutorInfo}
          // isLiteTutor={isLiteTutor}
          isLiteTutor={false}
          // liteLocation={liteLocation}
          liteLocation={{ country: "Nigeria" }}
          {...otherProps}
        />
      </Box>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

window.loadApplication = loadApplication;
window.CLIENT_PAGES = CLIENT_PAGES;
window.initializeAdmin = initializeAdmin;
window.unMountReviewComponent = unMountReviewComponent;
window.renderReviewComponent = renderReviewComponent;
window.renderReviewGuarantors = renderReviewGuarantors;
window.unMountReviewGuarantors = unMountReviewGuarantors;
window.unMountSalesModal = unMountSalesModal;
window.renderSalesModal = renderSalesModal;
window.initializeFollowupAdmin = initializeFollowupAdmin;
window.renderJobApplicationButton = renderJobApplicationButton;
window.unMountJobApplication = unMountJobApplication;
window.unMountLinkRequestModal = unMountLinkRequestModal;
window.linkRequestModal = linkRequestModal;
window.loadWhatsappView = sendWhatsappMessageToClient;
window.loadSplitView = displaySplitBreakdown;
window.loadSplitBreakdown = displaySplitBreakdown;
window.loadTutorVideoIntro = loadTutorVideoIntro;
window.loadCustomSearch = customSearch;
console.log("AAPLICATION LOADED");
// window.unMountRequestFollowUp = unMountRequestFollowUp;

// window.INITIAL_DATA = initialData;
// if (process.env.NODE_ENV !== "production") {
//   loadApplication(CLIENT_PAGES.PERSONAL_INFO, initialData, PROXY_URL);
// }
